/* eslint-disable import/no-unresolved */
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  Stack,
  Button,
} from '@mui/material';
import { Dayjs } from 'dayjs';
import TimePicker from '@/components/ReportFilter/utils/TimePicker';

const boxStyle = {
  position: 'absolute',
  height: 'fit-content',
  width: '500px',
  backgroundColor: '#fff',
  borderRadius: '15px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 4,
};

interface TimePickerProps {
  show: boolean;
  handleAction: () => void;
  handleModalClose: () => void;
  handleChangeFromTime: (value: Dayjs | null) => void;
  handleChangeToTime: (value: Dayjs | null) => void;
  fromTime: Dayjs | null;
  toTime: Dayjs | null;
}
const TimePickerModal: React.FC<TimePickerProps> = ({
  show,
  handleAction,
  handleModalClose,
  handleChangeFromTime,
  handleChangeToTime,
  fromTime,
  toTime,
}) => (
  <div>
    <Modal
      open={show}
      onClose={() => handleModalClose()}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Slide direction="up" in={show} mountOnEnter unmountOnExit>
        <Box sx={boxStyle}>
          <Box
            sx={{
              width: '20%',
              mr: 'auto',
              position: 'absolute',
              top: '0',
              left: '0',
            }}
          >
            <Button
              type="button"
              onClick={handleModalClose}
              sx={{ borderRadius: '100px' }}
            >
              Close
            </Button>
          </Box>
          <Typography textAlign="left" fontWeight={600} mt={4}>
            Filter By Time
          </Typography>
          <Stack mt={1} spacing={2}>
            <Box sx={{ display: 'flex', gap: '6px' }}>
              <TimePicker
                label="From Time"
                handleChange={handleChangeFromTime}
                value={fromTime}
              />
              <TimePicker
                label="To Time"
                handleChange={handleChangeToTime}
                value={toTime}
              />
            </Box>

            <Button
              type="button"
              variant="contained"
              onClick={handleAction}
              disableElevation
            >
              Continue
            </Button>
          </Stack>
        </Box>
      </Slide>
    </Modal>
  </div>
);

export default TimePickerModal;
